import { Card, Typography } from '@mui/material';

interface CompanyInitialDepositInfoProps {
  initialDepositAmount?: number;
}

const CompanyInitialDepositInfo = ({
  initialDepositAmount = 0,
}: CompanyInitialDepositInfoProps) => {
  const formatCurrency = (amount: number): string => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    }).format(amount);
  };

  return (
    <Card sx={{ p: 2, mb: 2 }}>
      <Typography variant="h6" sx={{ mb: 1, fontWeight: 'bold' }}>
        Initial Deposit Minimum for New Bank Accounts
      </Typography>
      <Typography>{formatCurrency(initialDepositAmount)}</Typography>
    </Card>
  );
};

export default CompanyInitialDepositInfo;
